<template>
  <component
    :class="[componentData.name.toLowerCase(), { disabled: !componentData.component.enabled }]"
    :is="cmpType"
    :cmpConfig="componentData"
    :fwParams="instanceParams"
    :valueSet="valueSet"
  ></component>
</template>

<script>
import _find from 'lodash/find';
import cwDropdownWrapper from './cwDropdownWrapper.vue';
import cwDropdownBoxWrapper from './cwDropdownBoxWrapper.vue';
import cwSliderWrapper from './cwSliderWrapper.vue';
import cwSwitchWrapper from './cwSwitchWrapper';
import cwTextInputWrapper from './cwTextInputWrapper';
import cwSplitBoxWrapper from './cwSplitBoxWrapper';
import cwTextInputMergerWrapper from './cwTextInputMergerWrapper';

import cwCollapsableWrapper from './cwCollapsableWrapper';

export default {
  name: 'CwGeneric',
  components: {
    cwDropdownWrapper,
    cwDropdownBoxWrapper,
    cwSliderWrapper,
    cwSwitchWrapper,
    cwTextInputWrapper,
    cwSplitBoxWrapper,
    cwTextInputMergerWrapper,
    cwCollapsableWrapper
  },
  props: {
    componentData: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      gRules: [],
      cactusElements: require('./cactus_elements.json')
    };
  },
  computed: {
    cmpType() {
      if (!this.componentData.component) return;

      let regExp = /([_])([a-zA-Z])/gm;
      let cmp = this.componentData.component.type;

      let matchGroups = cmp.match(regExp);
      if (matchGroups) {
        matchGroups.forEach(el => {
          cmp = cmp.replace(el, el.toUpperCase().replace('_', ''));
        });
      }

      return `cw${cmp.charAt(0).toUpperCase()}${cmp.substring(1)}Wrapper`;
    },

    instanceParams() {
      const paramNameArr = this.componentData.instance_param_name || [];

      // Ensure to get all params
      if (this.componentData.component.type === 'split_box') {
        const paramArr = [];
        paramNameArr.map(item => {
          let param = _find(this.cactusElements.parameters, { name: item });
          if (param) {
            paramArr.push(param);
          }
        });

        return paramArr;
      }

      return paramNameArr.map(item => {
        if (this.cactusElements.system_params[item]) {
          return {
            [item]: {
              ...this.cactusElements.system_params[item]
            }
          };
        }
        if (this.cactusElements.firmware_params[item]) {
          return {
            [item]: {
              ...this.cactusElements.firmware_params[item]
            }
          };
        }
      });
    },

    valueSet() {
      const valueSetName = ((this.componentData.value || {}).default || {}).values_set || '';
      if (valueSetName) {
        let obj = _find(this.cactusElements.values, { name: valueSetName });
        if (obj) {
          return obj.set;
        }
      }
      return [];
    }
  },
  created() {
    if (this.componentData.hasOwnProperty('rule_subscriber')) {
      this.gRules = this.componentData.rule_subscriber;
    } else this.gRules.push({});
  },
  mounted() {
    this.$parent.isGroupVisible(this.gRules);
  }
};
</script>

<style scoped></style>
